import React, { useContext } from 'react'
import { Text } from 'oio-react'
import PropTypes from 'prop-types'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'

const Title = ({ children, color, size }) => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)

   const textProps = {
      lg: {
         size: theme.tmpTitleLgSize,
         letterSpacing: theme.tmpTitleLgLetterSpacing
      },
      xl: {
         size: theme.tmpTitleXlSize,
         letterSpacing: theme.tmpTitleLgLetterSpacing
      },
      md: {
         size: theme.tmpTitleMdSize,
         letterSpacing: theme.tmpTitleMdLetterSpacing
      }
   }

   return (
      <Text
         color={color || theme.tmpContentTitleColor}
         fontFamily={theme.tmpTitleFontFamily}
         lineHeight="130%"
         {...textProps[size]}>
         {children}
      </Text>
   )
}

Title.propTypes = {
   color: PropTypes.string,
   size: PropTypes.oneOf(['md', 'lg', 'xl'])
}

Title.defaultProps = {
   color: undefined,
   size: 'lg'
}

export default Title
